import { h, defineAsyncComponent } from "vue";

export const AsyncIcon = defineAsyncComponent({
	loader: () => import("./Icon").then((module) => module.Icon),
	loadingComponent: () => h("div", "Loading..."),
	delay: 200,
	timeout: 3000,
});
